import { createFocusContainer, removeFocusContainer, addTimer } from "../helpers-focus.js";

/*
 * Adds a focus container with a button that counts clicks
 */
function likeTime({ gameState, board }) {
  const focusContainer = createFocusContainer({ board });
  const likeButton = document.createElement("button");
  let totalSeconds = 5;
  return new Promise((resolve) => {
    const { timerDiv, startTimer, getSeconds } = addTimer(totalSeconds, () => {
      removeFocusContainer(focusContainer, { board });
      resolve();
    });
    let count = 0
    let clicksForPoint = 1;
    likeButton.innerText = `🤍 ${count}`;
    focusContainer.appendChild(timerDiv);
    focusContainer.appendChild(likeButton);

    likeButton.addEventListener('click', () => {
      const COUNT_BASIS = 3;
      if (getSeconds() <= 0) return;
      likeButton.innerText = `❤️  ${++count}`

      if (count === clicksForPoint) {
        gameState.updateScore(100);
        clicksForPoint = clicksForPoint * COUNT_BASIS;
      }
    })

    startTimer();

  });
}

export default likeTime;
